import React from 'react'
import { useSelector } from 'react-redux'

import { Link } from 'pharmacy/src/navigation/link'
import { getAppHeader } from 'mednet-util/src/header'

import { useEnableV2FeedPage } from 'mednet-cns/src/hooks/gregorFlags'

export default function TopicLink({ topicObject, ...linkProps }) {
  const { topic, topicId } = topicObject
  const userData = useSelector((state) => state.user.data || {})
  const enableV2FeedPage = useEnableV2FeedPage()

  const linkParams = userData ? { specialtyId: userData.specialtyId } : null

  // Only use V2 routing if we're NOT in the mobile app
  const isInWeb = typeof window !== 'undefined' && getAppHeader()

  const pathname =
    isInWeb && enableV2FeedPage
      ? `/v2/topic/${topicId}/questions`
      : `/topic/${topicId}`

  return (
    <Link pathname={pathname} params={linkParams} {...linkProps}>
      {topic}
    </Link>
  )
}
